import { Routes, Route } from "react-router-dom";

import Home from "../pages/Home";
import About from "../pages/About";
import Contact from "../pages/Contact";
import Space from "../pages/Space";
import Events from "../pages/Events";
import Member from "../pages/Member";
import Career from "../pages/Career";
import Faq from "../pages/Faq";
import Bloq from "../pages/Blog";
import Service from "../pages/Services";
import Location from "../pages/Location";
import Price from "../pages/Price";
import Virtual from "../pages/Virtual";
import PrivateOffices from "../pages/PrivateOffices";
import ExectiveOffices from "../pages/ExectiveOffices";
import Cont from "../pages/Cont";
import Privacy from "../pages/Privacy";
import Newpage from "../pages/Newpage";
import XceedLanding from "../pages/XceedLanding";

// 404 Page
const NotFound = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        background: "#0b0b0b",
        color: "#fff",
        padding: "40px 20px",
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          maxWidth: "700px",
          width: "100%",
          margin: "0 auto",
          textAlign: "center",
        }}
      >
        <h1
          style={{
            margin: "0",
            fontSize: "140px",
            lineHeight: "1",
            fontWeight: "800",
            color: "#F4C430",
            textAlign: "center",
          }}
        >
          404
        </h1>

        <h2
          style={{
            margin: "25px 0 15px",
            fontSize: "48px",
            lineHeight: "1.2",
            fontWeight: "800",
            color: "#ffffff",
            textAlign: "center",
          }}
        >
          Page Not Found
        </h2>

        <p
          style={{
            margin: "0 auto 35px",
            fontSize: "22px",
            lineHeight: "1.6",
            fontWeight: "600",
            color: "#ffffff",
            textAlign: "center",
          }}
        >
          Sorry, the page you are looking for does not exist.
        </p>

        <a
          href="/"
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "14px 28px",
            background: "#F4C430",
            color: "#111",
            textDecoration: "none",
            borderRadius: "6px",
            fontSize: "16px",
            fontWeight: "700",
          }}
        >
          Go Back Home
        </a>
      </div>
    </div>
  );
};

const Routers = () => {
  return (
    <Routes>

      {/* HOME */}
      <Route path="/" element={<Home />} />
      <Route path="/home" element={<Home />} />

      {/* MAIN PAGES */}
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />


    
      {/* LOCATION */}
      <Route
        path="/uptown-post-oak"
        element={<Location />}
      />

      {/* PRICING */}
      <Route
        path="/pricing"
        element={<Price />}
      />

      {/* OFFICE */}
      <Route
        path="/virtual-office"
        element={<Virtual />}
      />

      <Route
        path="/private-offices"
        element={<PrivateOffices />}
      />

      <Route
        path="/executive-suites"
        element={<ExectiveOffices />}
      />

      {/* EVENTS */}
      <Route
        path="/xceed-networking-event"
        element={<Cont />}
      />

      {/* PRIVACY */}
      <Route
        path="/Privacy-Policy"
        element={<Privacy />}
      />

      {/* REALTOR PARTNER */}
      <Route
        path="/realtor-partner"
        element={<Newpage />}
      />

      {/* REALTOR PARTNER */}
      <Route
        path="/lp/galleria-private-office-offer"
        element={<XceedLanding />}
      />

      {/* =========================
          404 / INVALID URL
          MUST BE LAST
      ========================= */}
      <Route
        path="*"
        element={<NotFound />}
      />



    </Routes>
  );
};

export default Routers;